document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function(block = document) {
        const switchers = block.querySelectorAll('.content-switcher');
        if (!switchers.length) return;

        function applyDynamicHeight(panel, open) {
            const content = panel.querySelector('.content-switcher__panel-content');
            if (!content) return;

            if (open) {
                content.style.maxHeight = 'none';
                const natural = content.scrollHeight;
                content.style.maxHeight = '0px';
                content.offsetHeight;
                content.style.maxHeight = natural + 'px';
            } else {
                const current = content.scrollHeight;
                content.style.maxHeight = current + 'px';
                content.offsetHeight;
                content.style.maxHeight = '0px';
            }
        }

        function ensureObserver(panel) {
            const content = panel.querySelector('.content-switcher__panel-content');
            if (!content) return;
            if (panel.__csResizeObserver) return;

            if (typeof window.ResizeObserver === 'undefined') return;
            try {
                const ro = new ResizeObserver(() => {
                    if (panel.classList.contains('active')) {
                        const c = panel.querySelector('.content-switcher__panel-content');
                        if (c) c.style.maxHeight = c.scrollHeight + 'px';
                    }
                });
                ro.observe(content);
                panel.__csResizeObserver = ro;
            } catch (err) {
               
            }
        }

        function disconnectObserver(panel) {
            if (panel && panel.__csResizeObserver) {
                try { panel.__csResizeObserver.disconnect(); } catch(e) {}
                panel.__csResizeObserver = null;
            }
        }

        switchers.forEach(switcher => {
            const tabs = switcher.querySelectorAll('.content-switcher__tab');
            const panels = switcher.querySelectorAll('.content-switcher__panel');
            const isMobile = window.matchMedia('(max-width: 960px)').matches;
            let activeTabIndex = 0;
            tabs.forEach((tab, index) => {
                if (tab.classList.contains('active') || tab.getAttribute('aria-selected') === 'true') {
                    activeTabIndex = index;
                }
            });
            if (activeTabIndex === 0) {
                panels.forEach((panel, index) => {
                    if (panel.classList.contains('active') && !panel.hasAttribute('hidden')) {
                        activeTabIndex = index;
                    }
                });
            }
            switcher.querySelectorAll('.content-switcher__panel-header').forEach(h => h.remove());

            if (isMobile) {
                panels.forEach((panel, index) => {
                    if (!panel.previousElementSibling?.classList.contains('content-switcher__panel-header')) {
                        const header = document.createElement('button');
                        header.className = 'content-switcher__panel-header';
                        header.type = 'button';
                        const correspondingTab = tabs[index];
                        header.textContent = correspondingTab?.textContent?.trim() || 'Panel';
                        header.addEventListener('click', () => {
                            const isActive = panel.classList.contains('active');
                            panels.forEach(p => {
                                p.classList.remove('active');
                                applyDynamicHeight(p, false);
                                disconnectObserver(p);
                                const prevHeader = p.previousElementSibling;
                                if (prevHeader && prevHeader.classList.contains('content-switcher__panel-header')) {
                                    prevHeader.classList.remove('active');
                                    prevHeader.setAttribute('aria-expanded', 'false');
                                }
                            });

                            if (!isActive) {
                                panel.classList.add('active');
                                header.classList.add('active');
                                header.setAttribute('aria-expanded', 'true');
                                applyDynamicHeight(panel, true);
                                ensureObserver(panel);
                                panel.querySelectorAll('img').forEach(img => {
                                    if (!img.complete) {
                                        img.addEventListener('load', function onloadImg() {
                                            setTimeout(() => {
                                                const c = panel.querySelector('.content-switcher__panel-content');
                                                if (panel.classList.contains('active') && c) c.style.maxHeight = c.scrollHeight + 'px';
                                            }, 60);
                                            img.removeEventListener('load', onloadImg);
                                        });
                                    }
                                });
                            }
                        });

                        panel.parentNode.insertBefore(header, panel);
                    }

                    panel.removeAttribute('hidden');
                    if (index === activeTabIndex) {
                        panel.classList.add('active');
                        const justCreatedHeader = panel.previousElementSibling;
                        if (justCreatedHeader && justCreatedHeader.classList.contains('content-switcher__panel-header')) {
                            justCreatedHeader.classList.add('active');
                            justCreatedHeader.setAttribute('aria-expanded', 'true');
                        }
                        applyDynamicHeight(panel, true);
                        ensureObserver(panel);
                    } else {
                        panel.classList.remove('active');
                        const content = panel.querySelector('.content-switcher__panel-content');
                        if (content) content.style.maxHeight = '0px';
                        disconnectObserver(panel);
                    }
                });
            } else {
                if (panels.length > 0) {
                    panels.forEach((panel, index) => {
                        if (index === activeTabIndex) {
                            panel.classList.add('active');
                            panel.removeAttribute('hidden');
                            const content = panel.querySelector('.content-switcher__panel-content');
                            if (content) {
                                content.style.maxHeight = 'none';
                                content.style.overflow = '';
                            }
                            disconnectObserver(panel);
                        } else {
                            panel.classList.remove('active');
                            panel.setAttribute('hidden', '');
                            const content = panel.querySelector('.content-switcher__panel-content');
                            if (content) content.style.maxHeight = '';
                            disconnectObserver(panel);
                        }
                    });

                    tabs.forEach((tab, index) => {
                        if (index === activeTabIndex) {
                            tab.setAttribute('tabindex', '0');
                            tab.setAttribute('aria-selected', 'true');
                            tab.classList.add('active');
                        } else {
                            tab.setAttribute('tabindex', '-1');
                            tab.setAttribute('aria-selected', 'false');
                            tab.classList.remove('active');
                        }
                    });
                }

                tabs.forEach((tab, tabIndex) => {
                    if (tab.dataset.csInit) return;
                    tab.dataset.csInit = '1'
                    tab.addEventListener('keydown', (e) => {
                        let newIndex = tabIndex;
                        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                            newIndex = (tabIndex + 1) % tabs.length;
                            e.preventDefault();
                        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                            newIndex = (tabIndex - 1 + tabs.length) % tabs.length;
                            e.preventDefault();
                        }
                        if (newIndex !== tabIndex) {
                            tabs[newIndex].click();
                            tabs[newIndex].focus();
                        }
                    });

                    tab.addEventListener('click', () => {
                        const panelId = tab.getAttribute('aria-controls');
                        const targetPanel = switcher.querySelector(`#${panelId}`);
                        if (!targetPanel) return;

                        tabs.forEach(t => {
                            t.setAttribute('aria-selected', 'false');
                            t.setAttribute('tabindex', '-1');
                            t.classList.remove('active');
                        });
                        tab.setAttribute('aria-selected', 'true');
                        tab.setAttribute('tabindex', '0');
                        tab.classList.add('active');

                        const currentPanel = switcher.querySelector('.content-switcher__panel.active');

                        if (currentPanel && currentPanel !== targetPanel) {
                            currentPanel.classList.add('fade-out');
                            currentPanel.classList.remove('active');
                            disconnectObserver(currentPanel);

                            setTimeout(() => {
                                currentPanel.classList.remove('fade-out');
                                currentPanel.setAttribute('hidden', '');
                                targetPanel.removeAttribute('hidden');
                                targetPanel.classList.add('active');
                                targetPanel.offsetHeight;
                                targetPanel.classList.add('fade-in');
                                const content = targetPanel.querySelector('.content-switcher__panel-content');
                                if (content) { content.style.maxHeight = 'none'; content.style.overflow = ''; }

                                setTimeout(() => { targetPanel.classList.remove('fade-in'); }, 50);
                            }, 50);
                        } else if (currentPanel === targetPanel) {
                            return;
                        } else {
                            panels.forEach(p => {
                                if (p !== targetPanel) {
                                    p.classList.remove('active');
                                    p.setAttribute('hidden', '');
                                    const c = p.querySelector('.content-switcher__panel-content');
                                    if (c) c.style.maxHeight = '';
                                    disconnectObserver(p);
                                }
                            });
                            targetPanel.removeAttribute('hidden');
                            targetPanel.classList.add('active');
                            const content = targetPanel.querySelector('.content-switcher__panel-content');
                            if (content) content.style.maxHeight = 'none';
                        }
                    });
                });
            }
        });
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                initializeBlock();
            }, 250);
        });
    };
    
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=content-switcher', initializeBlock);
    } else {
        initializeBlock();
    }
});